// extracted by mini-css-extract-plugin
export default {"dialog":"RequestDialog_dialog__2DVP0","close":"RequestDialog_close__1RJY8"};